import ContactForm from "@/components/ContactForm";
import { NavLink } from "@/components/NavLink";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { Button } from "@/components/ui/button";

const EventInfo = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const restoredFormData = location.state?.formData;
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isCheckingSession, setIsCheckingSession] = useState(true);

  // Create session ID if it doesn't exist
  useEffect(() => {
    const initSession = () => {
      let sessionId = sessionStorage.getItem('session_id');
      if (!sessionId) {
        sessionId = crypto.randomUUID();
        sessionStorage.setItem('session_id', sessionId);
      }
      setIsCheckingSession(false);
    };
    initSession();
  }, []);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setIsAuthenticated(!!session);
    });

    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      setIsAuthenticated(!!session);
    });

    return () => subscription.unsubscribe();
  }, []);

  return (
    <div className="min-h-screen bg-background">
      {/* Navigation */}
      <nav className="sticky top-0 w-full z-50 border-b bg-background">
        <div className="container mx-auto px-4 sm:px-6 py-4 flex items-center justify-between">
          <h1 
            className="text-xl sm:text-2xl font-bold bg-gradient-to-r from-primary to-primary/60 bg-clip-text text-transparent cursor-pointer hover:opacity-80 transition-opacity"
            onClick={() => navigate("/")}
          >
            The Lost Strings
          </h1>
          <div className="flex gap-3 sm:gap-6 items-center">
            {isAuthenticated ? (
              <Button variant="outline" size="sm" onClick={() => navigate("/dashboard")}>
                Dashboard
              </Button>
            ) : (
              <Button variant="default" size="sm" onClick={() => navigate("/auth")}>
                Sign In
              </Button>
            )}
          </div>
        </div>
      </nav>

      {/* Event Form Section */}
      <section className="py-20" id="event-section">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="max-w-3xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-3xl sm:text-4xl font-bold mb-4">Event Details</h2>
              <p className="text-lg text-muted-foreground">
                Tell us about your event - Step 2 of 2
              </p>
            </div>
            <ContactForm initialData={restoredFormData} initialFormStep={2} />
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-8 border-t">
        <div className="container mx-auto px-4 sm:px-6 text-center text-sm text-muted-foreground">
          <p>&copy; {new Date().getFullYear()} The Lost Strings. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default EventInfo;
